import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'pl',
    fullName: 'Polish',
    nativeName: 'Polski',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Nadchodzi coś niesamowitego",
    landing_subtitle: "ArgVoid to studio tworzenia aplikacji i gier. Bądźcie czujni, już niedługo nowości!",
    select_language: "Wybierz Język",
    search_placeholder: "Wyszukaj języki...",
    terms_title: "Warunki świadczenia usług",
    policy_title: "Polityka prywatności",
    cookies_title: "Polityka plików cookie",
    terms_content: `
        <strong>1. Akceptacja Warunków</strong><br>
        Uzyskując dostęp do ArgVoid, akceptujesz niniejsze Warunki świadczenia usług. W przypadku braku zgody na niniejsze warunki nie należy korzystać z usługi.<br><br>

        <strong>2. Wykorzystanie platformy</strong><br>
        ArgVoid i jego aplikacje są dostarczane w stanie „takim, jakim są” w celach informacyjnych i kreatywnych. Z usługi można korzystać wyłącznie w celach zgodnych z prawem.<br><br>

        <strong>3. Zabronione postępowanie</strong><br>
        Wykorzystywanie luk w zabezpieczeniach witryny, spamowanie lub próby nieautoryzowanego dostępu do infrastruktury są surowo zabronione.<br><br>

        <strong>4. Zastrzeżenie </strong><br>
        Platforma i usługi mogą być modyfikowane w dowolnym momencie i bez powiadomienia. Nie udziela się żadnej gwarancji dotyczącej czasu pracy i dostępności usługi.
    `,
    policy_content: `
        <strong>1. Zbieranie informacji</strong><br>
        Platforma nie wymaga obecnie uwierzytelniania użytkownika ani tworzenia konta. Od odwiedzających nie są aktywnie zbierane żadne dane osobowe (takie jak imiona i nazwiska lub adresy e-mail).<br><br>

        <strong>2. Dane użytkowania</strong><br>
        Podstawowe, anonimowe dane analityczne mogą być gromadzone w celu zrozumienia ruchu w witrynie i ulepszenia aplikacji. Dane te nie są łączone z indywidualną tożsamością użytkownika.<br><br>

        <strong>3. Usługi stron trzecich</strong><br>
        Dostawcy zewnętrzni mogą być wykorzystywani do świadczenia usług hostingowych i analitycznych. Zasady ochrony prywatności tych odpowiednich dostawców regulują anonimowe dane przetwarzane w ich infrastrukturze.<br><br>

        <strong>4. Bezpieczeństwo danych</strong><br>
        Wdrożono rozsądne środki bezpieczeństwa w celu ochrony platformy. Żadna metoda transmisji przez Internet nie jest jednak całkowicie bezpieczna.<br><br>
    `,
    cookies_content: `
        <strong>1. Co to są pliki cookie i pamięć lokalna? </strong><br>
        Pliki cookie i lokalna pamięć przeglądarki to małe pliki danych przechowywane na urządzeniu w celu zapamiętania preferencji konfiguracyjnych podczas wizyt.<br><br>

        <strong>2. Cel użycia</strong><br>
        Browser LocalStorage służy wyłącznie do zapisywania ustawień konfiguracyjnych, takich jak:<br>
        - Preferencje językowe<br>
        - Konfiguracja interfejsu użytkownika (np. ustawienia układu lub motywu) <br>
        - Tymczasowa pamięć podręczna aplikacji<br><br>

        <strong>3. Brak śledzenia</strong><br>
        Pliki cookie i pamięć lokalna nie są wykorzystywane do celów reklamowych ani śledzenia przez osoby trzecie. Wszystkie przechowywane dane są przeznaczone wyłącznie dla podstawowej funkcjonalności platformy.<br><br>

        <strong>4. Sterowanie</strong><br>
        Dane przeglądarki można w każdej chwili wyczyścić poprzez ustawienia przeglądarki, co spowoduje zresetowanie wszelkich konfiguracji lokalnych.
    `,
    cookie_consent_text: "Używamy podstawowych plików cookie, aby zapewnić prawidłowe działanie witryny, takie jak utrzymanie aktywności sesji, zapisanie Twoich preferencji językowych i innych niestandardowych konfiguracji.",
    read_policy: "Przeczytaj Politykę plików cookie",
    support_title: "Skontaktuj się z pomocą techniczną",
    support_subject_label: "Temat",
    support_message_label: "Wiadomość",
    support_submit_button: "Wyślij wiadomość",
    support_hint: "Uwaga: Spowoduje to otwarcie domyślnej aplikacji e-mail, w której możesz wysłać wiadomość.",
    support_success_msg: "Otwieram aplikację e-mail...",
    support_error_msg: "Nie udało się wysłać wiadomości. Spróbuj ponownie później.",
    explorer_title: "Odkrywca",
    history_title: "Historia",
    animation_title: "Ożywienie",
    config_title: "Konfiguracja",
    tool_mouse: "Wybierz (Ctrl+M)",
    tool_brush: "Pędzel (Ctrl+B)",
    tool_brush_mode: "Tryb przełączania (stały/wyraźny)",
    tool_eraser: "Gumka (Ctrl+E)",
    tool_brush_size: "Dostosuj rozmiar pędzla",
    tool_bucket: "Wypełnij (Ctrl+F)",
    tool_eyedropper: "Kroplomierz",
    tool_grid: "Siatka (Ctrl+Shift+B)",
    tool_rotate: "Obróć (Ctrl+Shift+R)",
    tool_flip_h: "Odwróć H (Ctrl+Shift+H)",
    tool_flip_v: "Odwróć V (Ctrl+Shift+V)",
    tool_transpose: "Transpozycja (Ctrl+Shift+T)",
    label_width: "Szerokość",
    label_height: "Wysokość",
    label_frames: "Liczba klatek",
    label_animation: "Styl animacji",
    label_background_color: "Kolor tła",
    label_interval: "Interwał",
    tool_anim_config: "Konfiguracja animacji",
    label_new_width: "Nowa szerokość",
    label_new_height: "Nowa wysokość",
    label_apply: "Stosować",
    label_colors: "Zabarwienie",
    label_size: "Rozmiar",
    label_tolerance: "Tolerancja",
    val_horizontal: "Poziomy",
    val_vertical: "Pionowy",
    val_sequence: "Sekwencja",
    val_bounce: "Odbić się",
    val_random: "Losowy",
    val_solid: "Solidny",
    val_clear: "Jasne",
    action_add_sheet: "Nowy arkusz",
    action_import: "Import",
    action_export: "Eksport",
    action_sort_projects: "Sortować",
    sort_date_old: "Najpierw najstarszy",
    sort_date_new: "Najpierw najnowsze",
    sort_name_az: "Imię (A-Z)",
    sort_name_za: "Imię (Z-A)",
    action_new_sprite: "Nowy Sprite",
    action_new_project: "Nowy projekt",
    modal_save_all_title: "Zapisz wszystkie zmiany",
    modal_save_all_desc: "Wybierz zasoby do zapisania:",
    modal_save_selected: "Zapisz wybrane",
    action_saved: "Zapisano",
    modal_create_sprite_title: "Utwórz nowego duszka",
    modal_create_project_title: "Utwórz nowy projekt",
    modal_add_sheet_title: "Dodaj nowy arkusz",
    modal_rename_sheet_title: "Zmień nazwę arkusza",
    modal_rename_sprite_title: "Zmień nazwę Sprite'a",
    modal_delete_sprite_title: "Usuń Sprite'a",
    modal_delete_project_title: "Usuń projekt",
    modal_delete_sheet_title: "Usuń arkusz",
    placeholder_sprite_name: "Nazwa",
    placeholder_project_name: "Nazwa",
    placeholder_sheet_name: "Nazwa",
    placeholder_new_name: "Nowa nazwa",
    action_create: "Tworzyć",
    action_add: "Dodać",
    action_rename: "Przemianować",
    action_duplicate: "Duplikat",
    action_delete: "Usuwać",
    action_cancel: "Anulować",
    confirm_delete_sprite: "Czy na pewno chcesz usunąć tego duszka?",
    confirm_delete_project: "Czy na pewno chcesz usunąć ten projekt? Wszystkie duszki zostaną usunięte.",
    confirm_delete_sheet: "Czy na pewno chcesz usunąć ten arkusz?",
    err_select_sprite: "Najpierw wybierz duszka.",
    err_select_project: "Najpierw wybierz projekt.",
    err_name_empty: "Nazwa nie może być pusta.",
    err_sprite_exists: "Duszek o tej nazwie już istnieje.",
    err_project_exists: "Projekt o tej nazwie już istnieje.",
    err_no_content: "Brak treści do zapisania.",
    err_no_changes: "Brak zmian do zapisania.",
    err_delete_last_sheet: "Nie można usunąć ostatniego arkusza.",
    err_extract_frames: "Nie można wyodrębnić żadnych klatek.",
    err_indexeddb: "Nie udało się zapisać lokalnie. Twoja przeglądarka może nie obsługiwać IndexedDB.",
    msg_upload_success: "Przesyłanie powiodło się: {0}",
    msg_upload_failed: "Przesyłanie nie powiodło się: {0}",
    msg_save_success: "Zapisz pomyślnie.",
    msg_saving: "Oszczędność...",
    msg_multi_save_result: "Zapisano zasoby: {0}. {1} niepowodzeń.",
    menu_title: "Menu",
    menu_save: "Ratować",
    menu_save_all: "Zapisz wszystko",
    menu_support: "Skontaktuj się z pomocą techniczną",
    label_local_storage: "Magazyn lokalny",
    label_sign_in: "Zalogować się",
    modal_export_title: "Eksportuj Sprite'a",
    label_filename: "Nazwa pliku",
    label_format: "Format",
    action_export_confirm: "Eksport",
};

export default translations;
